import { Action as RootAction } from '@occc-app/rootRedux/action';

import { default as types, State } from './types';

import { types as csvUploadTypes } from '../../CSVUpload/redux';

export const initialState: State = {
  uploading: false,
};

export function reducer(state: State = initialState, action: RootAction) {
  let uploading;
  switch (action.type) {
    case types.CLEAR_CSV_UPLOAD_STATE:
      return {
        ...state,
        uploading: false,
      };
    case csvUploadTypes.CREATE_CSV_UPLOAD:
      if (action.action === 'addSegmentMemberships') {
        return {
          ...state,
          uploading: true,
        };
      }
      return state;
    case csvUploadTypes.CREATE_CSV_UPLOAD_ERROR:
      return {
        ...state,
        uploading: false,
      };
    case csvUploadTypes.CREATE_CSV_UPLOAD_OK:
      uploading = state.uploading as boolean;
      uploading = action.csvUpload.action === 'addSegmentMemberships' ? false : uploading;
      return {
        ...state,
        uploading,
      };
  }
  return state;
}
